<!-- @prettier -->
<template>
  <div class="py-3 lg:py-5">
    <div class="card">
      <header>
        <a
          href="https://warehousequote.com"
          target="_blank"
          rel="noopener"
          ><img
            :src="whqLogoWhite"
            alt="WarehouseQuote Header Logo"
        /></a>
      </header>
      <main class="min-h-30rem"><router-view /></main>
      <footer>
        Questions? Call us at
        <a
          href="tel:816-317-0706"
          style="color: #000000; text-decoration: underline"
          >816-317-0706</a
        >.
      </footer>
    </div>
  </div>
</template>

<script setup>
  import whqLogoWhite from "@/images/whq-logo-color-white-horizontal.png";
</script>

<style lang="scss" scoped>
  .card {
    width: 512px;
    max-width: calc(100vw - 3rem);
    margin: 0 auto;
    padding: 0;
    header {
      padding: 1rem 0;
      background-color: #212121;
      border-radius: 5px 5px 0 0;
      > a {
        display: block;
        width: 13.6rem;
        margin: 0 auto;
        > img {
          display: block;
          width: 100%;
        }
      }
    }
    main {
      padding: 1rem;
      @media (min-width: $breakpoint-sm) {
        padding: 2rem;
      }
    }
    footer {
      background-color: #eeeeee;
      padding: 1rem;
      text-align: center;
      border-radius: 0 0 5px 5px;
    }
  }
</style>
